<template>
    <header>
      <!-- <ul>
        <li>
          <router-link to="/">Home</router-link>
          <router-link to="/about">About</router-link>
          <router-link to="/portfolio">Portfolio</router-link>
        </li>
      </ul> -->

      <ul class="nav nav-tabs md-tabs" >
        <li class="nav-item">
          <a href="/">
            <img class="logo" src="../../static/img/logoFinal.png" />
          </a>
        </li>

        <li class="nav-item">
          <a href="/" class="nav-link color-text" :class="makeActiveMenu('/')">Trang chủ</a>
        </li>
        <li class="nav-item">
          <a href="/bai-hat" class="nav-link color-text" :class="makeActiveMenu('/bai-hat')">Bài hát</a>
        </li>
        <li class="nav-item">
          <a href="/bxh" class="nav-link color-text" :class="makeActiveMenu('/bxh')">BXH</a>
        </li>
        <li class="nav-item">
          <a class="nav-link color-text" href="/nghe-si" :class="makeActiveMenu('/nghe-si')">Nghệ sĩ</a>
        </li>
        <li class="nav-item">
          <a href="/giai-tri" class="nav-link color-text d-none" :class="makeActiveMenu('/giai-tri')">Giải trí</a>
        </li>
        <li class="nav-item">
          <a class="nav-link color-text" href="/huong-dan" :class="makeActiveMenu('/huong-dan')">Hướng dẫn</a>
        </li>
        <li class="nav-item">
          <!--<input type="text" class="inp-search bg-blue" name="search" placeholder="Tìm kiếm bài hát, ca sĩ,..."/>-->
          <autocomplete
            @nameSearch="textSearch=$event"
            :place-holder-text="placeHolderInputText"
            :result-items="autoCompleteResult"
            :result-song-items="autoCompleteSongResult"
            :result-singer-items="autoCompleteSingerResult"
            :on-selected="onSelectedAutoCompleteEvent"
            :on-selected-singer="onSelectedSingerAutoCompleteEvent"
            :on-arrow-down="onArrowDown"
            :on-arrow-up="onArrowUp"
            :on-enter="onEnter"
            :auto-complete-progress="autoCompleteProgress"
            :item-text="autoCompleteText"
            :item-id="autoCompleteFieldId"
            :value-arrow-counter="arrowCounter"
            :value-arrow-counter-singer="arrowCounterSinger"
            :value-input="valueSelected">
          </autocomplete>
        </li>
        <li class="nav-item">
          <a class="nav-link btn-register" v-if="!$session.exists()" data-toggle="modal" data-target="#mdRegister">Đăng ký</a>
        </li>
        <li class="nav-item">
            <a class="nav-link btn-login" v-if="!$session.exists()" data-toggle="modal" data-target="#mdSignin">Đăng nhập</a>
        </li>
        <li class="nav-item">
            <a class="nav-link btn-login ml-2" v-if="$session.exists()" @click="logout()" style="cursor: pointer;">Đăng xuất</a>
        </li>
        <li class="nav-item">
          <a href="javascript:void(0)" class="nav-link" v-if="$session.exists()">
            {{ $session.exists() && $session.has('userInfo') ? $session.get('userInfo').user.substr(0, 7) + 'XXXX' : '' }}
          </a>
        </li>
      </ul>
      <br/><br/><br/><br/><br/>
      <input type="hidden" v-model="$route.path"/>
      <signin></signin>
    </header>
</template>

<script>
  import Signin from './Signin'
  import Autocomplete from './Autocomplete'
  export default {
    name: 'Header',
    components: {
      Signin,
      Autocomplete
    },
    data () {
      return {
        active: 'active',
        placeHolderInputText: 'Tìm kiếm bài hát, ca sĩ',
        autoCompleteResult: [],
        autoCompleteSongResult: [],
        autoCompleteSingerResult: [],
        autoCompleteProgress: false,
        autoCompleteText: "name",
        autoCompleteFieldId: "inputSearch",
        valueSelected: null,
        arrowCounter: 0,
        arrowCounterSinger: -1,
        textSearch: "",
        check: ""
      }
    },
    created () {
      //Kiểm tra xem IP truy cập có phải là nhà mạng mobifone không
      /*if(!this.$session.exists() && this.$route.query.link == undefined){
        axios.get(api.checkTelco)
          .then(response => {
            if(response.data != "#"){
              window.location.href = response.data;
            }
          })
          .catch(e => {
            console.log("Lỗi check telco");
            console.log(e);
          })
      }*/

      //Bắt số điện thoại
      /*if(this.$route.query.link != "" && this.$route.query.link != undefined){
        axios.post(api.getPhone, JSON.stringify({ link: this.$route.query.link }))
          .then(response => {
            var res = response.data;
            if(res.msg = "success" && res.phone != false){
              this.$session.start();
              this.$session.set('userInfo', {'user': res.phone, 'token': ''});
              this.$router.push("/");
            }
          })
          .catch(e => {
            console.log(e);
          });
      }*/
    },
    mounted () {

    },
    methods: {
      makeActiveMenu (path) {
        var currentUrl = this.$route.path;
        var active = (this.$route.path === path) || (path != "/" && currentUrl.indexOf(path) > -1) ? 'active' : '';
        return active;
      },
      logout () {
        this.$session.destroy();
        //this.$router.push("/");
        window.location.href = "/";
      },
      onSelectedAutoCompleteEvent (songId, songName) {
        this.autoCompleteProgress = false;
        this.autoCompleteSongResult = [];
        this.autoCompleteSingerResult = [];
        this.valueSelected = songName;
        this.$router.push(this.settings.prefixSong + songId + '/' + this.convertToAlias(songName) );
      },

      onSelectedSingerAutoCompleteEvent (code, singerName) {
        this.autoCompleteProgress = false;
        this.autoCompleteSingerResult = [];
        this.autoCompleteSongResult = [];
        this.valueSelected = singerName;
        this.$router.push(this.settings.prefixSinger + code );
      },

      onKeyUpAutoCompleteEvent () {
        //RESET
        this.arrowCounter = 0;
        this.arrowCounterSinger = -1;
        this.autoCompleteSongResult = [];
        this.autoCompleteSingerResult = [];
        this.autoCompleteResult = [];
        this.autoCompleteProgress = false;

        if (this.textSearch.length > 2) {
          this.autoCompleteProgress = true;
          axios.post(api.search, {"keyword": this.textSearch})
            .then(response => {
              this.autoCompleteSongResult = response.data.result.songList;
              this.autoCompleteSingerResult = response.data.result.singerList;
              this.autoCompleteProgress = false;

              if(this.autoCompleteSongResult.length == 0){
                this.arrowCounterSinger = 0;
              }
            })
            .catch(e => {
              console.log(e);
            });
        } else {
          this.autoCompleteProgress = false;
          this.autoCompleteSongResult = [];
        }
      },
      onArrowDown() {
        if (this.arrowCounter < this.autoCompleteSongResult.length) {
          this.arrowCounter = this.arrowCounter + 1;
        }

        if(this.arrowCounter == this.autoCompleteSongResult.length && this.autoCompleteSongResult.length > 0){
          if(this.autoCompleteSingerResult.length > 0){
            if (this.arrowCounterSinger < this.autoCompleteSingerResult.length) {
              this.arrowCounterSinger++;
            }

            if(this.arrowCounterSinger == this.autoCompleteSingerResult.length){
              this.arrowCounterSinger = -1;
              this.arrowCounter = 0;
            }
          } else {
            this.arrowCounter = 0;
          }
        }

        if(this.autoCompleteSongResult.length == 0){
          if (this.arrowCounterSinger < this.autoCompleteSingerResult.length) {
            this.arrowCounterSinger++;
          }

          if(this.arrowCounterSinger == this.autoCompleteSingerResult.length){
            this.arrowCounterSinger = 0;
          }
        }
      },
      onArrowUp() {
        if (this.arrowCounter > 0 && this.arrowCounterSinger == -1 && !this.check) {
          this.arrowCounter = this.arrowCounter - 1;
        }

        if (this.arrowCounterSinger > 0) {
          this.arrowCounterSinger--;
          this.arrowCounter = -1;
        } else {
          this.check = true;
          this.arrowCounterSinger = -1;
          if(this.arrowCounter == -1){
            this.arrowCounter = this.autoCompleteSongResult.length;
          }
          if (this.arrowCounter > 0) {
            this.arrowCounter = this.arrowCounter - 1;
          }
        }
      },
      onEnter() {
        if(this.autoCompleteSongResult.length > 0 && this.autoCompleteSingerResult.length == 0){
          this.$router.push(this.settings.prefixSong + this.autoCompleteSongResult[this.arrowCounter].songId + '/' + this.convertToAlias(this.autoCompleteSongResult[this.arrowCounter].songName) );
          this.valueSelected = this.autoCompleteSongResult[this.arrowCounter].songName;
          this.autoCompleteProgress = false;
          this.autoCompleteSongResult = [];
          this.arrowCounter = -1;
        }

        if(this.autoCompleteSingerResult.length > 0 && this.autoCompleteSongResult.length == 0){
          this.$router.push(this.settings.prefixSinger + this.autoCompleteSingerResult[this.arrowCounterSinger].id );
          this.valueSelected = this.autoCompleteSingerResult[this.arrowCounterSinger].singerName;
          this.autoCompleteProgress = false;
          this.autoCompleteSingerResult = [];
          this.arrowCounterSinger = -1;
        }

        if(this.autoCompleteSongResult.length > 0 && this.autoCompleteSingerResult.length > 0){
          if(this.arrowCounterSinger > 0 && this.arrowCounterSinger != -1){
            this.$router.push(this.settings.prefixSinger + this.autoCompleteSingerResult[this.arrowCounterSinger].id)
            this.valueSelected = this.autoCompleteSingerResult[this.arrowCounterSinger].singerName;
            this.autoCompleteProgress = false;
            this.autoCompleteSingerResult = [];
            this.autoCompleteSongResult = [];
            this.arrowCounterSinger = -1;
          } else {
            this.$router.push(this.settings.prefixSong + this.autoCompleteSongResult[this.arrowCounter].songId + '/' + this.convertToAlias(this.autoCompleteSongResult[this.arrowCounter].songName) );
            this.valueSelected = this.autoCompleteSongResult[this.arrowCounter].songName;
            this.autoCompleteProgress = false;
            this.autoCompleteSingerResult = [];
            this.autoCompleteSongResult = [];
            this.arrowCounter = -1;
          }
        }

      }
    },

    watch: {
      "textSearch": {
        handler: "onKeyUpAutoCompleteEvent",
        immediate: true
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue